<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/admin"></ion-back-button>
    </ion-buttons>
    <ion-title>Notifications</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-grid>
    <form #notificationForm="ngForm" (ngSubmit)="onSubmit(notificationForm)">
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-item color="lightmimbo">
            <ion-input
              name="topic"
              label="Topic"
              labelPlacement="floating"
              ngModel
              required
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-item color="lightmimbo">
            <ion-input
              label="URL"
              labelPlacement="floating"
              name="url"
              ngModel
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-item color="lightmimbo">
            <ion-input
              name="title"
              label="Title"
              labelPlacement="floating"
              ngModel
              required
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-item color="lightmimbo">
            <ion-textarea
              label="Message"
              labelPlacement="floating"
              name="message"
              ngModel
              required
              rows="10"
              placeholder="Enter your message here..."
            ></ion-textarea>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          sizeMd="10"
          offsetMd="1"
          sizeXl="6"
          offsetXl="3"
          class="ion-text-center"
        >
          <ion-button type="submit" [disabled]="!notificationForm.valid"
            ><ion-icon name="send-outline" slot="start"></ion-icon> Send
            Notification</ion-button
          >
        </ion-col>
      </ion-row>
    </form>
  </ion-grid>
</ion-content>
